import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('influencer');
const GET_INFLUENCER_USERS = define('GET_INFLUENCER_USERS', true);
const GET_INFLUENCER_USER = define('GET_INFLUENCER_USER', true);
const SET_INFLUENCER_DETAIL_BY_TYPE = define('SET_INFLUENCER_DETAIL_BY_TYPE', true);

const initialState = {
  loading: false,
  users: [],
  user: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_INFLUENCER_USERS.PENDING:
      return {
        ...state,
        loading: true,
        users: {},
      };
    case GET_INFLUENCER_USERS.RESOLVED:
      return {
        ...state,
        users: action.data,
        loading: false,
      };
    case GET_INFLUENCER_USERS.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case GET_INFLUENCER_USER.PENDING:
      return {
        ...state,
        loading: true,
        user: {},
      };
    case GET_INFLUENCER_USER.RESOLVED:
      return {
        ...state,
        user: action.data,
        loading: false,
      };
    case GET_INFLUENCER_USER.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case SET_INFLUENCER_DETAIL_BY_TYPE.PENDING:
      return {
        ...state,
        loading: true,
        user: {},
      };
    case SET_INFLUENCER_DETAIL_BY_TYPE.RESOLVED:
      return {
        ...state,
        user: action.data,
        loading: false,
      };
    case SET_INFLUENCER_DETAIL_BY_TYPE.REJECTED:
      return {
        ...state,
        loading: false,
      };
    default: return state;
  }
};

export const actions = {
  getInfluencerUsers: () => ({
    type: GET_INFLUENCER_USERS,
    promise: api.get('/influencer/users')
  }),
  getInfluencerUser: (id) => ({
    type: GET_INFLUENCER_USER,
    promise: api.get(`/influencer/users/${id}`)
  }),
  setInfluencerDetailByType: (data) => ({
    type: SET_INFLUENCER_DETAIL_BY_TYPE,
    promise: (async () => {
      await api.put('/influencer/detail', data);
      const user = await api.get(`/influencer/users/${data.user_id}`);
      return user;
    })()
  })
};



// WEBPACK FOOTER //
// ./src/ducks/influencer.js